import React, { useState } from "react";
import "./VolunteerForm.css";

const VolunteerForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    city: "",
    interests: [],
    experience: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => {
        const updated = checked
          ? [...prev.interests, value]
          : prev.interests.filter((i) => i !== value);
        return { ...prev, interests: updated };
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch("https://your-domain.com/api/volunteer-form", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setIsSubmitted(true);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      setError("Network error. Please try again later.");
    }
  };

  if (isSubmitted) {
    return (
      <div className="volunteer-form-success">
        <h2>Thank you for volunteering!</h2>
        <p>We’ve received your details. Our team will contact you soon.</p>
      </div>
    );
  }

  return (
    <div className="enquiry-form-wrapper">
        <h2 className="form-heading">
          Join as a <span className="highlight">Volunteer</span>
        </h2>
      <form className="custom-form" onSubmit={handleSubmit}>
        

        <div className="form-group">
          <label>Full Name</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Phone</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>City</label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            required
          />
        </div>

        <fieldset className="form-group">
          <legend>Areas of Interest</legend>
          {[
            "Teaching",
            "Event Support",
            "Fundraising",
            "Creative/Arts",
            "Admin/Tech",
          ].map((interest) => (
            <label key={interest}>
              <input
                type="checkbox"
                name="interests"
                value={interest}
                checked={formData.interests.includes(interest)}
                onChange={handleChange}
              />
              {interest}
            </label>
          ))}
        </fieldset>

        <div className="form-group">
          <label>Brief Volunteering Experience (if any)</label>
          <textarea
            name="experience"
            value={formData.experience}
            onChange={handleChange}
            placeholder="Tell us briefly about your past volunteering experience..."
          />
        </div>

        <button type="submit" className="submit-btn">Submit</button>
        {error && <p className="error">{error}</p>}
      </form>
    </div>
  );
};

export default VolunteerForm;
